<div class="marker">
  <div class="marker_label">{{ label }}</div>
  <div class="marker_value">{{ value }}</div>
</div>
